var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 70,
    viewBox: "0 0 51 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M25.6667 40.3816C25.2267 40.3816 24.7967 40.2688 24.4167 40.0554L1.91664 27.3091C1.53662 27.0939 1.22106 26.7844 1.00165 26.4116C0.782252 26.0388 0.666748 25.616 0.666748 25.1856C0.666748 24.7552 0.782252 24.3323 1.00165 23.9595C1.22106 23.5868 1.53662 23.2772 1.91664 23.062L24.4167 10.3255C25.1917 9.89149 26.1418 9.89149 26.9168 10.3255L49.4169 23.062C49.7969 23.2772 50.1124 23.5868 50.3318 23.9595C50.5512 24.3323 50.6667 24.7552 50.6667 25.1856C50.6667 25.616 50.5512 26.0388 50.3318 26.4116C50.1124 26.7844 49.7969 27.0939 49.4169 27.3091L26.9168 40.0554C26.5364 40.2696 26.1053 40.3821 25.6667 40.3816Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.4169 32.8696L44.5068 30.0889L26.9168 40.0544C26.1418 40.4909 25.1917 40.4909 24.4167 40.0544L6.82667 30.0889L1.91664 32.8696C1.53662 33.0848 1.22106 33.3944 1.00165 33.7672C0.782252 34.1399 0.666748 34.5628 0.666748 34.9932C0.666748 35.4236 0.782252 35.8464 1.00165 36.2192C1.22106 36.592 1.53662 36.9015 1.91664 37.1167L24.4167 49.863C25.1917 50.2995 26.1418 50.2995 26.9168 49.863L49.4169 37.1167C49.7969 36.9015 50.1124 36.592 50.3318 36.2192C50.5512 35.8464 50.6667 35.4236 50.6667 34.9932C50.6667 34.5628 50.5512 34.1399 50.3318 33.7672C50.1124 33.3944 49.7969 33.0848 49.4169 32.8696Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4169 42.6792L44.5068 39.8984L26.9168 49.864C26.1418 50.3005 25.1917 50.3005 24.4167 49.864L6.82667 39.8984L1.91664 42.6792C1.53662 42.8944 1.22106 43.204 1.00165 43.5767C0.782252 43.9495 0.666748 44.3723 0.666748 44.8027C0.666748 45.2332 0.782252 45.656 1.00165 46.0288C1.22106 46.4015 1.53662 46.7111 1.91664 46.9263L24.4167 59.6726C25.1917 60.1091 26.1418 60.1091 26.9168 59.6726L49.4169 46.9263C49.7969 46.7111 50.1124 46.4015 50.3318 46.0288C50.5512 45.656 50.6667 45.2332 50.6667 44.8027C50.6667 44.3723 50.5512 43.9495 50.3318 43.5767C50.1124 43.204 49.7969 42.8944 49.4169 42.6792Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.666748,
    y1: 24.9147,
    x2: 50.6667,
    y2: 24.9147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.666748,
    y1: 39.957,
    x2: 50.6667,
    y2: 39.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.666748,
    y1: 49.7665,
    x2: 50.6667,
    y2: 49.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.0170806397a2f927310252e847c34963.svg";
export { ForwardRef as ReactComponent };